module.exports = __webpack_public_path__ + "img/20180815_152858_230.f9794cae.jpg";